<template>
  <div>
    <select class="status-select" v-model="data.status" :disabled="isWorker()" :style="setColor()">
      <option v-for="option in options" :key="option.code" v-bind:value="option.code" :style="{color: `${option.color}`}">{{ option.label }}</option>
    </select>
    <!--<v-select transition="" :options="options" v-model="data.status" :reduce="(option) => option.code" :disabled="data.disabled"></v-select>-->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import optionList from '../../data/table/statusColumn'
//import $ from "jquery";

export default {
  name: "statusColumn",
  props: {
    data: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      options: optionList,
    }
  },
  methods: {
    setColor() {
		let colors = ['#777', '#090', 'red', 'red', 'red', 'red', 'red', 'red', 'red', 'red'];
        return 'color:'+colors[this.data.status];
	},
    isWorker() {
      if (this.data.disabled) {
        return true;
      } else {
        return !this.isAvailable(['admin', 'welder', 'customer', 'moderator']);
      }

    },
    isAvailable(roles) {
      return this.meRoles.map(item => roles.includes(item)).includes(true)
    }
  },
  computed: {
    ...mapGetters(['meRoles'])
  },
}
</script>


<style>
.vs__fade-enter-active,
.vs__fade-leave-active {
  transition: none;
}

.status-select {
  width: 160px;
}

select.status-select {
  padding: 0.375rem 0.75rem;

  height: 40px;

  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;

  border-radius: 0.25rem;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
</style>
